import { Form, Input, Modal } from 'antd';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import IBroker from '~Api/Broker/IBroker';
import { brokerEmailAction } from '~Brokers/actions';
import ModalStateEnum from '~UI/ModalStateEnum';
import { IDictionary } from '~utilities/IDictionary';

interface IDefaultedValues {
    email: string;
}

export default function EmailModal(props: {
    broker: IBroker;
    isOpen: ModalStateEnum;
    onCancel: () => void;
}): ReactElement {
    const { isOpen, broker, onCancel } = props;
    const [dirtyFields, setDirtyFields] = useState<IDictionary<boolean>>({});
    const [email, setEmail] = useState<string>(null);

    const dispatch: Dispatch = useDispatch();

    const getDefaultedValues: () => IDefaultedValues = () => ({
        email: dirtyFields.email ? email : broker.email ?? null,
    });

    const { email: defaultedEmail } = getDefaultedValues();

    const onChangeEmail: (event: React.ChangeEvent<HTMLInputElement>) => void = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
        setDirtyFields((prev: IDictionary<boolean>) => ({ ...prev, email: true }));
    }, []);

    const onClickCancel: () => void = useCallback(() => {
        setEmail(null);
        setDirtyFields({});
        onCancel();
    }, [
        onCancel,
    ]);

    const onClickUpdate: () => void = useCallback(() => {
        dispatch(brokerEmailAction(broker.uuid, defaultedEmail));
        onClickCancel();
    }, [
        broker.uuid,
        defaultedEmail,
        dispatch,
        onClickCancel,
    ]);

    return (
        <Modal
            okText='Update'
            onCancel={onClickCancel}
            onOk={onClickUpdate}
            open={ModalStateEnum.Open === isOpen}
            title='Change Email'
            wrapClassName='broker-email-modal'
        >
            <Form.Item label='Email' className='email'>
                <Input onChange={onChangeEmail} value={defaultedEmail} />
            </Form.Item>
        </Modal>
    );
}